import api from '../lib/api';

// Offset (ms) such that "true server time" ~= Date.now() + offset.
// Starts at 0 so callers work correctly even before the first sync resolves.
let offset = 0;
let synced = false;
let syncPromise = null;
let intervalId = null;

// Estimates the server/client clock offset using a simple round-trip
// measurement (same idea as NTP): we bracket the request with local
// timestamps and assume the network latency is roughly symmetric, so the
// server's clock corresponds to the midpoint of our local request window.
const syncServerTime = async () => {
    const requestStart = Date.now();
    try {
        const { data } = await api.get('/server-time');
        const requestEnd = Date.now();
        const roundTrip = requestEnd - requestStart;
        const estimatedServerNow = data.serverTime + roundTrip / 2;
        offset = estimatedServerNow - requestEnd;
        synced = true;
    } catch (error) {
        // Keep the previous offset (or 0) if the sync request fails.
    }
};

// Kicks off an immediate sync plus a periodic resync so drift (and the
// initial estimate) keeps improving over the lifetime of the page. Safe to
// call multiple times - only the first call actually starts the interval.
export const startServerTimeSync = () => {
    if (!syncPromise) {
        syncPromise = syncServerTime();
    }
    if (!intervalId) {
        intervalId = setInterval(syncServerTime, 60000);
    }
    return syncPromise;
};

// Returns the best current estimate of "now" per the server's clock, in ms
// since epoch - use this instead of Date.now()/moment() for anything that
// must agree across every client (lot countdowns, auction start countdown).
export const getServerNow = () => Date.now() + offset;

export const isServerTimeSynced = () => synced;
